import { SectionOne, SectionTwo } from "../components/feature/serviceInvoice";


export default function ServiceInvoicePage()
{
    return(
        <section className="py-5 md:py-8 px-4 md:px-8 xl:px-10">
            <SectionOne/>
            <SectionTwo/>
        </section>
    );
}